module.exports = __webpack_public_path__ + "img/support.28a4b5bf.png";